import Modal from '../components/Modal';

export default class StaticFilters {
  constructor(section) {
    this.$el = $(section.el);
    this.context = section.data.context;
    this.filter_settings = section.data.filters;
    this.$advandedTags = this.$el.find('[data-tag-advanced] a');
    this.$filterGroups = this.$el.find('[data-filter-group]');
    this.$additionalTags = this.$el.find('[data-filter-toggle]');
    this.$gridContainer = $('[data-product-grid-wrapper]');
    this.$filtersTrigger = this.$gridContainer.find(
      '[data-productgrid-trigger-filters]'
    );
    this.filtersContent = '[data-productgrid-filters-content]';
    this.$allTags = this.$el.find(
      `${this.filtersContent} .filter-item a:not([data-filter-toggle])`
    );
    this._showFiltersModal = this._showFiltersModal.bind(this);

    this._toggleTags = this._toggleTags.bind(this);
    this._activateTag = this._activateTag.bind(this);
    this._advancedTags = this._advancedTags.bind(this);

    const modalCallbacks = {
      onOpen: this._onModalOpen,
      onClose: this._onModalClose
    };

    this.events = [
      this.$advandedTags.on('click.filters', this._advancedTags),
      this.$additionalTags.on('click.filters', this._toggleTags),
      this.$allTags.on('click.filters', this._activateTag),
      this.$filtersTrigger.on('click.filters', this._showFiltersModal)
    ];

    this.modal = new Modal(modalCallbacks);

    this._setupHiddenTags();
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.filters'));
  }

  /**
   * Hides tag filters
   *
   * @private
   */
  _setupHiddenTags() {
    const limit = this.filter_settings.limit;

    this.$filterGroups.each((i, filterGroup) => {
      const filters = filterGroup.querySelectorAll('[data-tag-advanced]');
      if (filters.length > limit) {
        filters.forEach((filter, index) => {
          if (index > limit - 1) {
            filter.classList.add('filter-item--hidden');
            filter.setAttribute('data-hidden-default', '');
          }
        });
      }
    });
  }

  /**
   * Expand / Collapse additional tags in the sidebar
   *
   * @param event
   * @private
   */
  _toggleTags(event) {
    event.preventDefault();

    const $trigger = $(event.currentTarget);

    const $items = $trigger.parent().siblings('[data-hidden-default]');
    const siblingsVisible = $trigger.data('filter-toggle');

    $items.toggleClass('filter-item--hidden', siblingsVisible);
    $trigger
      .data('filter-toggle', !siblingsVisible)
      .text(!siblingsVisible ? this.context.see_less : this.context.see_more);

    if (this.modal.isOpen()) {
      this.modal.position();
    }
  }

  /**
   * Style a tag as active after click, before page transition
   *
   * @param event
   * @private
   */
  _activateTag(event) {
    $(event.currentTarget).addClass('filter-link--active');
  }

  /**
   * Used by advanced tags to concatenate tag searches
   *
   * @param event
   * @private
   */
  _advancedTags(event) {
    const $target = $(event.currentTarget).parent();
    const tagGroup = $target.attr('data-group');
    const $activeGroup = $(`.filter-item--active[data-group="${tagGroup}"]`);

    if (!$target.hasClass('filter-item--active') && $activeGroup.length) {
      const tagHandle = $target.attr('data-handle');

      event.preventDefault();
      $target.siblings().removeClass('filter-item--active');

      location.href = location.href
        // swap tag
        .replace($activeGroup.attr('data-handle'), tagHandle)
        // go back to page 1
        .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, '');
    }
  }

  /**
   * Open Tags/Filters modal (on mobile)
   *
   * @param event
   * @private
   */
  _showFiltersModal(event) {
    event.preventDefault();

    this.$focusItem = $(event.currentTarget);
    this.modal.open(this.filtersContent, 'productgrid-filters');
  }
}
